import React from 'react';
import PropTypes from 'prop-types';
import IconWithLabel from '../../shared/IconWithLabel';
import { UX2 } from '@wsb/guac-widget-core';

const getLabel = (count, translate) => {
  const labelKey = count > 1 ? 'multiple' : 'one';
  const translateKey = `products.file_information.visiblity_link.file_count.${labelKey}`;

  if (count > 1) {
    return translate(translateKey, { count: count });
  }
  return translate(translateKey);
};

const FileDetailsLabel = ({ fileCount, translate }) => {
  return (
    <IconWithLabel
      containerMarginBottom='xsmall'
      icon='digitalProduct'
      labelText={ getLabel(fileCount, translate) }
      labelElement={ UX2.Element.Label }
    />
  );
};

FileDetailsLabel.propTypes = {
  translate: PropTypes.func,
  fileCount: PropTypes.number
};

export default FileDetailsLabel;
